import $axios from "../../api";

const state = () => ({
  list: [],
  loading: false,
  errors: null,
  detail: null,
});

const mutations = {
  ASSIGN_LIST(state, payload) {
    state.list = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  ASSIGN_DETAIL(state, payload) {
    state.detail = payload;
  },
};

const actions = {
  fetchList({ commit, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get("/website/seo/category/list")
        .then((response) => {
          commit("ASSIGN_LIST", response.data.data);
          resolve();
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error);

          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  update({ commit }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .put("/website/seo/category/update", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error);
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}